export const DefaultBreadCrumbItem = { id: '0', label: 'Catalogue' };
export const EntryListStorageKey = 'entry-treelist';
